<template>
  <div class="container" style="background-color: #fdfdfe">
    <div class="top_title">
      <!-- 返回按钮 -->
      <!--      <router-link class="icon_back" :to="{ name: 'H600030' }" tag="span"></router-link>-->
      <span>信息确认</span>
    </div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="weui-cells item" style="border: 0 !important; margin-top: 2.4rem">

        <div class="weui-cell" v-for="(item,index) in dataList" :key="index">
          <div class="weui-cell__bd">
            <p>{{ item.I_TEXT }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.I_VALUE }}</p>
          </div>
        </div>
      </div>
      <button class="bottom_btn" @click="onClickSearch">{{ I_REFUND_FLAG === 'Y' ? '查看电子合同' : '签署退费协议' }}</button>
<!--      <div style="font-size: 0.8rem;color: rgb(228,28,28);text-align: center;margin-top: 0.5rem">-->
<!--        ※退费户名必须与家长姓名一致-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import dataRequestFactory from "../factories/dataRequestFactory";

export default {
  data() {
    return {
      I_SCHOOL_VALUE: '',
      I_TEL: '',
      I_STUDENT_NAME: '',
      dataList: [],
      I_REFUND_FLAG: 'N',
      PDAPath: '',
    }
  },
  methods: {
    onClickSearch() {
      if (this.I_REFUND_FLAG === 'Y') {
        // 电子合同查看
        this.$router.push({
          name: 'H800040', params: {
            I_SCHOOL_NO: this.I_SCHOOL_VALUE,
            I_PHONE: this.I_TEL,
            I_STUDENT_NAME: this.I_STUDENT_NAME
          }
        })
      } else {
        // 电子合同签署
        let requestParams = {
          "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
          "I_PHONE": this.I_TEL,
          "I_STUDENT_NAME": this.I_STUDENT_NAME,
        }

        dataRequestFactory.I800021(requestParams).then(res => {
          if (res.resultCode === '0') {
            this.PDAPath = 'http://' +res.PDAPath
            this.$router.push({
              name: 'H800030',
              params: {
                I_SCHOOL_NO: this.I_SCHOOL_VALUE,
                I_PHONE: this.I_TEL,
                I_STUDENT_NAME: this.I_STUDENT_NAME,
                PDAPath: this.PDAPath,
              }
            })
          }
        }).catch(err => {
          if (err.errorDesc === '请选择校区') {
            this.$router.replace({name: 'H800010'})
          }
        })

      }
    }
  },
  mounted() {
    var win_h = $(window).height();  //关键代码
    $("body").height(win_h);  //关键代码

    let params = this.$route.params

    if (params.I_SCHOOL_NO) {
      this.I_SCHOOL_VALUE = params.I_SCHOOL_NO
    } else {
      this.I_SCHOOL_VALUE = window.localStorage.getItem("I_SCHOOL_NO") || ''
    }

    if (params.I_PHONE) {
      this.I_TEL = params.I_PHONE
    } else {
      this.I_TEL = window.localStorage.getItem("I_PHONE") || ''
    }

    if (params.I_STUDENT_NAME) {
      this.I_STUDENT_NAME = params.I_STUDENT_NAME
    } else {
      this.I_STUDENT_NAME = window.localStorage.getItem("I_STUDENT_NAME") || ''
    }

    let requestParams = {
      "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
      "I_PHONE": this.I_TEL,
      "I_STUDENT_NAME": this.I_STUDENT_NAME,
    }

    dataRequestFactory.I800020(requestParams).then(res => {
      if (res.resultCode === '0') {
        this.dataList = res.DataList
        this.I_REFUND_FLAG = res.I_REFUND_FLAG
      } else {
        weui.topTips(res.errorDesc);
      }
    }).catch(err => {
      if (err.errorDesc === '请选择校区') {
        this.$router.replace({name: 'H800010'})
      }
    })
  },
  created() {
    window.document.title='易文乐未消耗课时退费'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/H800020.vue